
/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Inventory {

    import fld = MixingItemsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class MixingItemsEditor extends Common.GridEditorBase<MixingItemsRow> {


        protected getColumnsKey() { return "Inventory.MixingItems"; }
        protected getDialogType() { return MixingItemsDialog; }
        protected getLocalTextPrefix() { return MixingItemsRow.localTextPrefix; }
        protected form: MixingItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        public Lotno: string;
        public TotalItems: number; 

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: false });
        }



        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this); 
            Q.first(columns, x => x.field === fld.Weight).format = num;

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion
         
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***

            if (field === fld.Weight) {
                if (item.CalcOnId != 3 && item.HasBom == false) {
                    var Net = (item.UnitRate) * value;
                    item.GrossAmount = Net;
                    item.NetWeight = value;

                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion

        //Set Data for New SKU Generated
        public setData(entity: any, AtbId: number, pieces: number,weight:number,productid:number) {
            var x = entity;
            var LotNo = FormatHelper.GetFormats("Lot");
            var netwtperitem = entity.NetWeight / entity.Pieces;

            let prddetails;
            OMS.ProductMasterService.Retrieve({
                EntityId: productid
            }, response => {
                prddetails = response.Entity
            }, { async: false });
            var item: MixingItemsRow = {
                ProductId: productid,
                ProductCode: prddetails.ProductCode,
                ProductName: prddetails.ProductName,
                AttributeId: AtbId,
                CalcOnId: x.CalcOn,
                CompanyId: x.CompanyId,
                DepartmentId: x.DepartmentId,
                SKU: "",
                LotNo: LotNo,

                Pieces: pieces,
                Weight: weight,
                NetWeight: netwtperitem,
                Line_No: x.LineNo == undefined ? x.Line_No : x.LineNo,
                ItemTypeId: x.ItemTypeId,
                ProductTypeId: x.ProductTypeId,
                CategoryId: x.CategoryId,
                SubCategoryId: x.SubCategoryId,
                BagNo: x.BagNo,
                CertificateNo: x.CertificateNo,
                Hsn: x.Hsn,
                RefTransId: entity.TransId,
                RefVoucherId: entity.VoucherTypeId,
                UnitRate: entity.UnitRate,
                GrossAmount: 1 * entity.NetAmount,
                HasBom: x.HasBom,

                //item.TransItemId = this.nextId++;
                
            }
            item[this.getIdProperty()] = "`" + this.nextId++;
            this.view.addItem(item);

        }

        public setOldItems(entity: any[]) {
            for (var i = 0; i < entity.length; i++) {
                entity[i][this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(entity[i]);
            }
        }
        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.StockStoneSelectGrid;
            
            buttons = buttons.filter(x => x.cssClass != "add-button");

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {
                    if (this.Lotno == "0" || this.Lotno == "" || this.Lotno == undefined) {
                        Q.alert('Lot needs to be selected first');
                        return;
                    }

                    var filters: _Ext.SelectGridFilters = {

                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true, title: "Select Items",
                        preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                    });


                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        //alert('Length' + selectedItems.length);
                        if (selectedItems2.length > 1) {
                            Q.alert('Only one item can be selected');
                            return;
                        } else {
                            var self = this;
                            var orddetails = [];
                            var deptId = this.DeptId; 
                            // #region Items to Grid
                            //for (let value of selectedItems2)
                            selectedItems2.forEach(function (value: Stock.StockItemRow) {
                                var PrdId = value.ProductId;
                                

                                var purchase: MixingDetailsRow = {
                                    ProductId: PrdId,
                                    AttributeId: value.AttributeId,
                                    Line_No: value.Line_No,
                                    SKU: value.SKU,
                                    DepartmentId: value.DepartmentId,
                                    ProductCode: value.ProductCode,
                                    ProductName: value.ProductName,
                                    ItemTypeId: value.ItemTypeId,
                                    CategoryId: value.CategoryId,
                                    ProductTypeId: value.ProductTypeId,
                                    SubCategoryId: value.SubCategoryId,
                                    LotNo: self.Lotno,
                                    UnitRate: value.Rate,
                                    //  UnitLabour: LaborRate,
                                    Pieces: value.Pieces,
                                    Weight: value.Weight,
                                    NetWeight: value.NetWeight == undefined ? value.Weight : value.NetWeight,
                                    CalcOnId: value.CalcOnId,
                                    SieveId: value.SieveId,
                                    QualityId: value.QualityId,
                                    ShapeId: value.ShapeId,
                                    StoneColorId: value.StoneColorId,
                                    StoneSizeId: value.StoneSizeId,
                                    //BOMDetails: bomdetails,
                                    //  LaborDetails: labordetail,
                                    CompanyId: value.CompanyId,
                                    TransId: value.TransId,
                                    VoucherTypeId: 74,
                                    RefVoucherId: value.VoucherTypeId,
                                    HasBom: value.HasBom,
                                    Hsn: value.HSN,
                                    RefTransId: value.TransId,
                                    RefTransItemId: value.TransItemId,

                                };
                                orddetails.push(purchase);

                            });


                            for (let orderDetail of orddetails) {
                                orderDetail[this.getIdProperty()] = "`" + this.nextId++;
                                this.view.addItem(orderDetail);
                            }
                        }

                    }

                    pickerDialog.dialogOpen();
                }
            });

             
            return buttons;
        } 
    }
}